<!--
yi_tabs 组件使用说明：

tabs 配置示例：
[
  { title: 'tab1', cache: false }, // cache: false 使用 v-if，每次切换都会重置
  { title: 'tab2', cache: true },  // cache: true 使用 v-show，保持状态
  { title: 'tab3', cache: false }  // 默认 cache: false
]

- cache: false (默认): 使用 v-if，每次进入 tab 都会重新创建组件，状态重置
- cache: true: 使用 v-show，组件保持状态，不会重置
-->
<style scoped="" type="text/css">
.yi-tabs-container {
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
}

.yi-tabs-header {
	flex-shrink: 0;
}

.yi-tabs-content {
	flex: 1;
	overflow: hidden;
}

.yi-tabs-pane {
	width: 100%;
	height: 100%;
	overflow: hidden;
}
</style>
<template>
	<div ref="tabsContainer" class="yi-tabs-container" :style="containerStyle">
		<div ref="tabsHeader" class="yi-tabs-header">
			<el-tabs v-model="activeTab" type="card" @tab-click="tabClick">
				<el-tab-pane v-for="tab in tabs" :key="tab.title" :label="$t(tab.title)" :name="tab.title">
				</el-tab-pane>
			</el-tabs>
		</div>
		<div ref="tabsContent" class="yi-tabs-content" :style="contentStyle">
			<template v-if="contentHeight > 0">
				<!-- 非缓存的 tab（使用 v-if） -->
				<div v-for="tab in tabs" v-if="showeds.indexOf(tab.title) !== -1 && !tab.cache && tab.title == activeTab" :key="tab.title" :name="tab.title" class="yi-tabs-pane">
					<slot :name="tab.title"></slot>
				</div>
				<!-- 缓存的 tab（使用 v-show） -->
				<div v-for="tab in tabs" v-if="showeds.indexOf(tab.title) !== -1 && tab.cache" :key="tab.title" :name="tab.title" class="yi-tabs-pane" v-show="tab.title == activeTab">
					<slot :name="tab.title"></slot>
				</div>
			</template>
			<template v-else>
				<!-- 占位或 loading，可自定义 -->
			</template>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'yi_tabs',
	components: {},
	props: {
		tabs: {
			type: Array,
			default: [{
				title: '',
				cache: false,
			}]
		}
	},
	data() {
		return {
			activeTab: this.tabs[0].title,
			showeds: [this.tabs[0].title], // 跟踪已显示的 tab
			contentHeight: 0,
			fixedContainerHeight: null
		}
	},
	watch: {

	},
	created() {
		setTimeout(() => {
			this.fixContainerHeight();
		}, 500);
	},
	mounted() {

	},
	beforeDestroy() {

	},
	computed: {
		containerStyle() {
			if (this.fixedContainerHeight) {
				return { height: this.fixedContainerHeight + 'px' };
			}
			return { height: '100%' };
		},
		contentStyle() {
			return {
				overflow: 'auto',
				height: this.contentHeight > 0 ? `${this.contentHeight}px` : 'auto'
			};
		}
	},
	methods: {
		tabClick(tab) {
			this.$nextTick(() => {
				// 将当前 tab 添加到已显示列表中
				if (this.showeds.indexOf(tab.name) === -1) {
					this.showeds.push(tab.name)
				}
				this.activeTab = tab.name
				this.utils.event_hub.$emit('RESIZE')
			})
		},
		fixContainerHeight() {
			this.$nextTick(() => {
				if (this.$refs.tabsContainer) {
					this.fixedContainerHeight = this.$refs.tabsContainer.offsetHeight;
				}
				this.calculateHeight();
			});
		},
		calculateHeight() {
			this.$nextTick(() => {
				if (this.$refs.tabsContainer && this.$refs.tabsHeader) {
					const containerHeight = this.$refs.tabsContainer.offsetHeight;
					const headerHeight = this.$refs.tabsHeader.offsetHeight;
					this.contentHeight = containerHeight - headerHeight;
					console.log('yi_tabs 高度计算:', {
						containerHeight,
						headerHeight,
						contentHeight: this.contentHeight
					});
				}
			});
		}
	}
}
</script>
